import { NgForOf } from "@angular/common";
import { Component, inject } from "@angular/core";
import { AccountMarketplace, OrganizationAmazonUserAccess } from "@front/m19-api-client";
import { AccountMarketplaceService } from "@front/m19-services";
import { IButtonComponent, MODAL_DATA, ModalRef, ToasterService } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { SpinnerComponent } from "@m19-board/spinner/spinner.component";
import { UntilDestroy } from "@ngneat/until-destroy";
import { take } from "rxjs/operators";

@UntilDestroy()
@Component({
  templateUrl: "./renew-amazon-access-modal.component.html",
  standalone: true,
  imports: [TranslocoDirective, NgForOf, IButtonComponent, SpinnerComponent],
})
export class RenewAmazonAccessModalComponent {
  modalData = inject(MODAL_DATA) as RenewAmazonAccessModalData;
  modalRef = inject(ModalRef);

  loading!: boolean;

  constructor(
    private accountMarketplaceService: AccountMarketplaceService,
    private toasterService: ToasterService,
  ) {}

  renew(): void {
    this.loading = true;
    this.accountMarketplaceService
      .addAmazonUser(this.modalData.organizationId, this.modalData.accountMarketplace)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.loading = false;
          this.toasterService.success("Access successfully renewed", "Login with Amazon");
          this.modalRef.close();
        },
        error: (errorMessage) => {
          this.loading = false;
          this.toasterService.error(errorMessage, "Login with Amazon error");
        },
      });
  }

  close() {
    this.modalRef.close();
  }
}

export interface RenewAmazonAccessModalData {
  amazonUserAccess: OrganizationAmazonUserAccess[];
  organizationId: number;
  accountMarketplace: AccountMarketplace;
  canLoginWithAmazon: boolean;
}
